import { PropTypes } from 'prop-types';
import React, { useMemo, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';

import { CollapsiblePanel } from '@ge/components/collapsible-panel';
import { useIsMobile } from '@ge/shared/data-hooks';
import { Loader } from '@ge/components/loader';
import { useManualAdjustmentContext } from '@ge/feat-analyze/context/manual-adjustment-context';
import { globalColors } from '@ge/tokens/colors';

import { SitePanelAssets } from './site-panel-assets';
import { SitePanelHeader } from './site-panel-header';

const CACollapsiblePanel = styled(CollapsiblePanel)`
  margin-bottom: 2px;
  .title {
    padding: 0 15px 0 7px;
    border-bottom: none;
    background-color: ${(props) => props.theme.analyze.manualAdjustment.panelsColor};
    cursor: pointer;
    svg {
      fill: ${globalColors.slate3};
    }
  }
  ${(props) => props.isMobile ? `.collapsible-panel-content {
      &.panel-loading,
      &.no-overflow {
        overflow: auto !important;
      }
    }`: ''}
`;

export const SitePanel = ({ isOverviewLoading, siteData }) => {
  const { t, ready } = useTranslation(['analyze.manual-adjustment'], {
    useSuspense: false,
  });
  const firstTimeRef = useRef(null);
  const location = useLocation();
  const isMobile = useIsMobile();

  const { selectedSite, handleSiteExpand, setSelectedSite } = useManualAdjustmentContext();

  const panelExpanded = useMemo(() => {
    if (location?.state?.siteId === siteData?.site?.id && !firstTimeRef.current) {
      setSelectedSite(siteData?.site);
      firstTimeRef.current = true;
      return true;
    } else return selectedSite && selectedSite.id === siteData?.site.id;
  }, [location?.state?.siteId, selectedSite, siteData?.site, setSelectedSite]);

  if (!ready || isOverviewLoading) {
    return <Loader />;
  }

  return (
    <CACollapsiblePanel
      headerContent={
        <SitePanelHeader
          site={siteData?.site}
          assetCount={siteData?.assetCount}
          title={t('lowest_performer', 'Lowest Performer')}
          lowestPerformer={siteData?.lowestPerformer}
        />
      }
      onToggleExpand={() => handleSiteExpand(siteData?.site)}
      expanded={panelExpanded}
      isMobile={isMobile}
    >
      {panelExpanded ? (
        <SitePanelAssets isOverviewLoading={isOverviewLoading} siteData={siteData} />
      ) : (
        <div></div>
      )}
    </CACollapsiblePanel>
  );
};

SitePanel.propTypes = {
  isOverviewLoading: PropTypes.bool,
  siteData: PropTypes.object.isRequired,
};
